<template>
  <div>
    <CCol ref="content" xs="12" lg="12">
      <CCard>
        <!-- <CCardHeader>Create a New Node</CCardHeader> -->
        <CCardBody>
          <v-card
            style="padding-top: 20px; padding-left: 20px; padding-right: 20px; padding-bottom: 30px;"
            shaped
          >
            <div class="md-layout-item md-size-100 md-large-size-100">
              <md-card>
                <md-card-header  style="  background-color:#31a9e1;">
                  <h4 class="title">  Ajouter un capteur </h4>
                </md-card-header>
                <md-card-content>
                  <HorizontalStepper></HorizontalStepper>
                </md-card-content>
              </md-card>
            </div>
          </v-card>
        </CCardBody>
      </CCard>
    </CCol>
  </div>
</template>

<script>
import Stepper from "../components/Cards/Stepper";
import router from "@/routes";
export default {
  components: {
    HorizontalStepper: Stepper
  },
  created() {
    /*  if(this.$store.state.Auth == false)
        router.push('/login')*/
  }
};
</script>